import { StaticBaseDao } from '@/dao';
import { DynamicReportRequest, ManagerReport, Report, GetDynamicReportParameterDataResponse } from '@/objects/generated';

export class ReportDao extends StaticBaseDao {
    public static async ReportFile(
        req: DynamicReportRequest,
        EventID: number,
    ): Promise<{ stream: ReadableStream<Uint8Array> | null; contentType: string | null; filename?: string }> {
        return this.PostRaw(`Report/ReportFile` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), req);
    }
    public static async ManagerReports(): Promise<ManagerReport[]> {
        return this.BaseFetchArray(ManagerReport, `Report/ManagerReports`, 'GET');
    }
    public static async Fetch(uids: number[], detailed: boolean): Promise<Report[]> {
        return this.BaseFetchArray(
            Report,
            `Report/Fetch` +
                '?' +
                (uids == undefined ? '' : `${this.makeGetStringFromList(uids, 'uids')}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'GET',
        );
    }
    public static async GetDynamicReportParameterData(
        reportUID: number,
        EventID: number,
    ): Promise<GetDynamicReportParameterDataResponse | null> {
        return this.BaseFetch(
            GetDynamicReportParameterDataResponse,
            `Report/GetDynamicReportParameterData` +
                '?' +
                (reportUID == undefined ? '' : `reportUID=${reportUID}`) +
                '&' +
                (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
        );
    }
}
